export default "__VITE_ASSET__BDwCC6xF__"